<template>
  <SelectSearchDropdown
    :options="options"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import SelectSearchDropdown from './SelectSearchDropdown.vue';

export default {
  name: 'currency-select',

  components: { SelectSearchDropdown },

  data() {
    return {
      options: [],
    };
  },

  async created() {
    const { data } = await this.$query(this.$queries.currencies);
    const currencies = (data || {}).currencys;
    this.options = currencies.map(currency => ({ value: currency.id, text: `${currency.symbol} (${currency.name})` }));
    if (!this.value && this.options.length) {
      this.$emit('input', this.options[0].value);
    }
  },

  props: { value: String },
};
</script>
